// Central brand + hero image assets for PurposePoint Collective
const BASE =
  "https://static.prod-images.emergentagent.com/jobs/1c646e73-3991-4deb-9e9d-27e0d854e41a/images";

export const ASSETS = {
  logoPP: `${BASE}/123e45793eb44163d2aeb575419cdc46a868ea73d2eca6c26bb4efe543b2c5cf.jpeg`,
  logoCCC: `${BASE}/249c2e43409fd69485cc19f183ea589a3af852754c2182117f71e5a5eacaf6db.jpeg`,
  craftyHero: `${BASE}/07cc8088fbce22ae8516c7450590d0c54772d5853657788fbb3883885eb4cad8.jpeg`,
  serveCpr: `${BASE}/e160201d3e0f6c8cddbfb8a60037a779d6bc1ed310e8819cecd9c66da2b76c1f.jpeg`,
  serveNotary: `${BASE}/42ddddbf593a189b331afbf9efda1d4daf713fdeaaa08a7749c7f313a09e1fd7.jpeg`,
  heroMemphis:
    "https://images.unsplash.com/photo-1577055383519-ca48a5d859be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  quoteBridge:
    "https://images.unsplash.com/photo-1600187230702-5f07aea6d7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};
